<script setup lang="ts">
import { computed, PropType } from "vue";
import { computeQuantities, getOutByIndex } from "@/shared/utils/outs";
import { Pool } from "@/models/pool.model";

const props = defineProps({
  out: { type: Object as PropType<Pool["outs"][number]>, required: true },
  pool: { type: Object as PropType<Pool>, required: true },
});

const outDef = computed(() => getOutByIndex(props.out.index));
const quantities = computed(() =>
  computeQuantities(
    props.out,
    props.pool,
    (q) => `<strong class="text-base font-medium">${q}</strong>`
  )
);
</script>

<template>
  <div class="card p-3 flex flex-col items-center" v-if="quantities.length > 0">
    <div class="text-white font-medium text-lg mb-1">
      {{ $t(outDef.consoLabel) }}
    </div>
    <div class="text-xs text-gray-200">
      <div
        v-for="(quantity, idx) in quantities"
        :key="idx"
        v-html="quantity"
      ></div>
    </div>
  </div>
</template>
